import React, { useEffect } from "react";
import Text from "../../../utils/Custom/text";
import { Autocomplete, TextField } from "@mui/material";
import { TextFields } from "../../../utils/Custom/custominput";
import { useParams } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { toast } from "react-toastify";
import { CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import { BASE_URL } from "../../../global";
import { booleanOptions, qmsAuditor } from "../../constants/inspectionOption";
import { getPermissions } from "../rbac/hasAccess";
const EditCamElectrical = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [inputStates, setInputStates] = React.useState({});
  const [usersList, setUsersList] = React.useState([]);
  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const getVal = (key) => inputStates[key] !== undefined && inputStates[key] !== null ? inputStates[key] : "";

  const onSubmit = () => {
    const url =
      BASE_URL + `cam_electrical_inst${params.id !== "0" ? `/${params.id}` : ""}`;
    const request =
      params.id !== "0"
        ? axiosWithToken.patch(url, inputStates)
        : axiosWithToken.post(url, inputStates);

    request
      .then(() => {
        toast.success(
          params.id !== "0" ? "Updated Successfully!" : "Created Successfully!"
        );
        setTimeout(() => params.id !== "0" ? window.location.reload() : window.history.back(), 500);
      })
      .catch((error) => console.error("Submit error:", error));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const users = await fetchQuery(`SELECT user.*, emp.name, emp.location FROM users user LEFT JOIN employees emp ON user.employeeId = emp.id WHERE user.type = 2 AND user.status = 1`);
        setUsersList(users);

        if (params.id != 0) {
          const [cam_electrical_inst] = await fetchQuery(`SELECT * FROM cam_electrical_inst WHERE id = ${params.id}`);

          if (cam_electrical_inst) {
            const selectedUser = users.find((item) => item.id == cam_electrical_inst.userID);
            setInputStates({
              ...cam_electrical_inst,
              location: selectedUser?.location || "",
            });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [params.id]);


  return (
    <div>
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {/* Name */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={usersList}
            getOptionLabel={(option) => `${option.name || ""} (${option.userName || ""})`}
            value={usersList.find((item) => item["id"] == getVal("userID")) || null}
            onChange={(event, value) => {
              updateInputObject("userID", value ? value.id : "");
              updateInputObject("location", value ? value.location : "");
            }}
            disabled={params.id != 0}
            renderInput={(params) => <TextField {...params} fullWidth label="Name" />}
          />
        </div>
        {/* Location */}
        <div className="w-full">
          <TextFields
            label="Location"
            value={getVal("location")}
            onChange={(e) => updateInputObject("location", e.target.value)}
            disabled={true}
          />
        </div>
        {/* Experience */}
        <div className="w-full">
          <TextFields
            label="Experience"
            value={getVal("experience")}
            onChange={(e) => updateInputObject("experience", e.target.value)}
          />
        </div>
        {/* Qualification */}
        <div className="w-full">
          <TextFields
            label="Qualification"
            value={getVal("qualification")}
            onChange={(e) => updateInputObject("qualification", e.target.value)}
            disabled={params.id != 0}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">
            ELECTRICAL EQUIPMENT
          </Text>
        </div>
        {/* Motors */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("motors")) || null}
            onChange={(event, value) => updateInputObject("motors", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Motors" />}
          />
        </div>
        {/* Control Panel */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("controlPanel")) || null}
            onChange={(event, value) => updateInputObject("controlPanel", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Control Panel" />}
          />
        </div>
        {/* Switch Gears */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("switchGears")) || null}
            onChange={(event, value) => updateInputObject("switchGears", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Switch Gears" />}
          />
        </div>
        {/* Generators */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("generators")) || null}
            onChange={(event, value) => updateInputObject("generators", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Generators" />}
          />
        </div>
        {/* Transformers */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("transformers")) || null}
            onChange={(event, value) => updateInputObject("transformers", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Transformers" />}
          />
        </div>
        {/* Cables & Wires */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("cablesWires")) || null}
            onChange={(event, value) => updateInputObject("cablesWires", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Cables & Wires" />}
          />
        </div>
        {/* Capacitors */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("capacitors")) || null}
            onChange={(event, value) => updateInputObject("capacitors", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Capacitors" />}
          />
        </div>
        {/* Battery Chargers & Inverters, UPS */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("chargersInvertersUPS")) || null}
            onChange={(event, value) => updateInputObject("chargersInvertersUPS", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="Battery Chargers & Inverters, UPS" />}
          />
        </div>
        {/* Instruments */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={booleanOptions}
            getOptionLabel={(option) => option["label"] || ""}
            value={booleanOptions.find((item) => item["id"] == getVal("instruments")) || null}
            onChange={(event, value) => updateInputObject("instruments", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="INSTRUMENTS" />}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">
            QMS+W3:W116 auditor
          </Text>
        </div>
        {/* System Auditor */}
        <div className="w-full">
          <Autocomplete
            size="small"
            options={qmsAuditor}
            getOptionLabel={(option) => option["label"] || ""}
            value={qmsAuditor.find((item) => item["id"] == getVal("systemAuditor")) || null}
            onChange={(event, value) => updateInputObject("systemAuditor", value ? value["id"] : "")}
            renderInput={(params) => <TextField {...params} fullWidth label="System Auditor" />}
          />
        </div>
        {/* Heading */}
        <div className="col-span-full">
          <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3">
            REMARK
          </Text>
        </div>
        {/* Remarks */}
        <div className="w-full">
          <TextFields
            label="Remarks"
            value={getVal("remarks")}
            onChange={(e) => updateInputObject("remarks", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
        </div>
      </div>
      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditCamElectrical;
